import { render } from "./uni_form.vue?vue&type=template&id=259c0132"
import script from "./uni_form.vue?vue&type=script&lang=js"
export * from "./uni_form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__